import { render, staticRenderFns } from "./GExamDetailEvalRequestModal.vue?vue&type=template&id=aff0b238&scoped=true&"
import script from "./GExamDetailEvalRequestModal.vue?vue&type=script&lang=ts&"
export * from "./GExamDetailEvalRequestModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff0b238",
  null
  
)

export default component.exports